import React from "react"
import styled from "styled-components"

import { Box } from "components/box"
import Image from "components/image"

import bgBeam from "assets/backgrounds/beam@2x.png"

import { Height } from "theme"

const BeamBox = styled(Box)`
  border-radius: 0.3125rem;
  border: solid 0.125rem ${props => props.theme.colors.apricot};
`

const BeamImage = () => (
  <BeamBox>
    <Image display="block" height={[65, null, 80] as Height} inheritSizes src={bgBeam} />
  </BeamBox>
)

export default BeamImage
